export class RequestReport {
    fromDate: string;
    toDate: string;

    constructor(
        fromDate: string,
        toDate: string
    ) {
        this.fromDate= fromDate;
        this.toDate= toDate;
    }
}